<template>
    <div id="banner"  @mouseover="onBannerMouseOver" v-if="storeBanner.bannerItem.length">
        <agile
            v-if="canStart"
            :arrows="true"
            :infinite="true"
            :autoplay="true"
            :autoplaySpeed=2000
            :fade="true"
            :dots="false"
            :prevArrow="leftArrorwEl" :nextArrow="rightArrowWl"
        >
            <template v-for="(item,index) in storeBanner.bannerItem">
                <div class="slide">
                    <a :target="item.target" :href="item.link" :alt="item.alt" :title="item.title">
                        <template v-for="(url, breakpoint) in item.image_url">
                            <img :class="breakpoint" :src="getImageApi+`/${url}`">
                        </template>
                    </a>
                </div>
            </template>

        </agile>
    </div>
</template>

<script>


    import Vue from 'vue';
    import VueAgile from 'vue-agile'
    import {banner} from '@store/banner';
    import {common} from "@mixins/common";
    import {storeMapper} from '@mixins/storeMapper';

    Vue.use(VueAgile)

    export default {
        name: "NswBanner",
        mixins:[common,storeMapper],
        data() {
            return {
                canStart:false,
                leftArrorwEl :"<div></div>",
                rightArrowWl: "<div></div>",
                getImageApi: getImageApi
            }
        },
        computed: {

        },
        mounted() {

        },
        methods: {
            getImageSrc(imageSrc) {
                return `@images/{$imageSrc}`;
            },
            startCarousel() {
                this.canStart = true;
            },
            onBannerMouseOver() {

            }
        }
    }
</script>

<style scoped lang="scss">


    #banner * {
        line-height:0;
    }

    #banner a {
        display:block;
    }
    #banner img {
        width:100%;
    }

</style>

<style lang="scss">

    @import "~@sass/_variables.scss";
    @import "~@sass/_mixins.scss";

    $tiny-max: 320; //tiny banner max width
    $small-max: 479; //small banner max width
    $medium-max: 767; //medium banner max width
    $large-max: 979; //large banner max width

    //vue-agile plugin overriding
    $agile-arrow-size:34px;
    $agile-arrow-color:white;
    $agile-arrow-margin:30px;

    .slide img {
        display:none;
    }

    @mixin tiny($prop...) {
        @media all and (max-width: $tiny-max * 1px) {
            @content;
        }
    }

    @mixin small($prop...) {
        @media all and  (min-width: $tiny-max + 1px) and (max-width: $small-max * 1px) {
            @content;
        }
    }

    @mixin medium($prop...) {
        @media all and (min-width: $small-max + 1px) and (max-width: $medium-max * 1px) {
            @content;
        }
    }

    @mixin large($prop...) {
        @media all and (min-width: $medium-max + 1px) and (max-width: $large-max * 1px) {
            @content;
        }
    }

    @mixin infinity($prop...) {
        @media all and (min-width: $large-max  + 1px) {
            @content;
        }
    }

    @include tiny {
        .tiny {
            display:block !important;
        }
    }

    @include small {
        .small {
            display:block !important;
        }
    }

    @include medium {
        .medium {
            display:block !important;
        }
    }

    @include large {
        .large {
            display:block !important;
        }
    }

    @include infinity {
        .infinity {
            display:block !important;
        }

    }

    #banner {

        .agile__arrow {
            @include background-opacity($agile-arrow-color, 0);
            position:absolute;
            top:50%;
            width:$agile-arrow-size;
            height:$agile-arrow-size;
            border-radius:50%;
            border:none;
            margin-top:calc(-0.5*$agile-arrow-size);
            -webkit-transition: background .2s ease-out;
            -moz-transition: background .2s ease-out;
            -o-transition: background .2s ease-out;
            transition: background .2s ease-out;
        }

        &:hover .agile__arrow {
            @include background-opacity($agile-arrow-color, 0.3);
        }

        .agile__arrow:hover {
            @include background-opacity-force($agile-arrow-color, 0.8);
        }

        .agile__arrow--prev {
            left:$agile-arrow-margin;
        }

        .agile__arrow--next {
            right:$agile-arrow-margin;
        }
    }

    @include narrow {
        #banner {
            margin:3.5rem 0 0 0;
        }
    }

</style>




// WEBPACK FOOTER //
// resources/assets/js/components/NswBanner.vue